// Phase 486 Plan 02 — runtime fetch loader for Phase 485 LLM-generated page trees.
//
// Files live at `cogo-web/apps/cogo-v77-demo/public/captures/*.page.json`
// (Plan 02 Task 1 ships them — genuine LLM output per D-486-05); Vite serves
// them at `/captures/*.page.json` in dev and Cloudflare Pages serves them at
// the same URL post-deploy (Pages serves `dist/**` verbatim; Vite copies
// `public/**` → `dist/**` at build time).
//
// Cache is REQUIRED by React 19's `use(promise)` Suspense pattern — creating a
// new promise per render would cause an infinite Suspense loop.
import type { SchemaV4Page } from "@cogo/react-renderer/adapters/schema-v4-page";

export type Scenario = "storefront" | "product-detail" | "checkout";

const cache = new Map<Scenario, Promise<SchemaV4Page>>();

export function loadPageTree(scenario: Scenario): Promise<SchemaV4Page> {
  if (!cache.has(scenario)) {
    cache.set(
      scenario,
      fetch(`/captures/${scenario}.page.json`).then((r) => {
        if (!r.ok) {
          throw new Error(`page-tree fetch ${scenario} → ${r.status}`);
        }
        return r.json() as Promise<SchemaV4Page>;
      }),
    );
  }
  return cache.get(scenario)!;
}
